// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empnotespage-inline-1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.empnotespage-inline-2 {
  font-size: 13px;
  color: var(--n-500);
}

.empnotespage-inline-3 {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 14px;
}

.empnotespage-inline-4 {
  padding: 14px 16px;
}

.empnotespage-inline-5 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.empnotespage-inline-6 {
  font-weight: 700;
  font-size: 14px;
}

.empnotespage-inline-7 {
  display: flex;
  gap: 4px;
}

.empnotespage-inline-8 {
  background: none;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  color: var(--n-500);
}

.empnotespage-inline-9 {
  background: none;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  color: var(--danger-500);
}

.empnotespage-inline-10 {
  font-size: 12px;
  color: var(--n-700);
  white-space: pre-wrap;
  line-height: var(--lh-normal);
}

.empnotespage-inline-11 {
  font-size: 10px;
  color: var(--n-400);
  margin-top: 10px;
}

.empnotespage-inline-12 {
  text-align: center;
  padding: 40px;
}

.empnotespage-inline-13 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-bottom: 8px;
}

.empnotespage-inline-13 svg {
  width: 32px;
  height: 32px;
}

.empnotespage-inline-14 {
  font-weight: 600;
  margin-bottom: 4px;
}

.empnotespage-inline-15 {
  font-size: 12px;
  color: var(--n-400);
}

.empnotespage-inline-16 {
  display: flex;
  gap: 8px;
}

.empnotespage-dyn-1 {
  background: var(--empnotespage-1-background);
  border: 1px solid var(--n-200);
}

.empnotespage-dyn-2 {
  width: 28px;
  height: 28px;
  border-radius: var(--radius-md);
  background: var(--empnotespage-2-background);
  border: var(--empnotespage-2-border);
  cursor: pointer;
  box-shadow: var(--empnotespage-2-box-shadow);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Employee/EmpNotesPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,4CAA4C;EAC5C,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,4CAA4C;EAC5C,oCAAoC;EACpC,eAAe;EACf,4CAA4C;AAC9C","sourcesContent":[".empnotespage-inline-1 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.empnotespage-inline-2 {\n  font-size: 13px;\n  color: var(--n-500);\n}\n\n.empnotespage-inline-3 {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n  gap: 14px;\n}\n\n.empnotespage-inline-4 {\n  padding: 14px 16px;\n}\n\n.empnotespage-inline-5 {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 8px;\n}\n\n.empnotespage-inline-6 {\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.empnotespage-inline-7 {\n  display: flex;\n  gap: 4px;\n}\n\n.empnotespage-inline-8 {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  color: var(--n-500);\n}\n\n.empnotespage-inline-9 {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  padding: 0;\n  color: var(--danger-500);\n}\n\n.empnotespage-inline-10 {\n  font-size: 12px;\n  color: var(--n-700);\n  white-space: pre-wrap;\n  line-height: var(--lh-normal);\n}\n\n.empnotespage-inline-11 {\n  font-size: 10px;\n  color: var(--n-400);\n  margin-top: 10px;\n}\n\n.empnotespage-inline-12 {\n  text-align: center;\n  padding: 40px;\n}\n\n.empnotespage-inline-13 {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  margin-bottom: 8px;\n}\n\n.empnotespage-inline-13 svg {\n  width: 32px;\n  height: 32px;\n}\n\n.empnotespage-inline-14 {\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.empnotespage-inline-15 {\n  font-size: 12px;\n  color: var(--n-400);\n}\n\n.empnotespage-inline-16 {\n  display: flex;\n  gap: 8px;\n}\n\n.empnotespage-dyn-1 {\n  background: var(--empnotespage-1-background);\n  border: 1px solid var(--n-200);\n}\n\n.empnotespage-dyn-2 {\n  width: 28px;\n  height: 28px;\n  border-radius: var(--radius-md);\n  background: var(--empnotespage-2-background);\n  border: var(--empnotespage-2-border);\n  cursor: pointer;\n  box-shadow: var(--empnotespage-2-box-shadow);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
